import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import validate from "utils/validate";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ButtonLoader, Input } from "components/__new/common/form";
import * as auth from "store/auth/user/action";

export const ForgotPassword = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { forgotPasswordLoading, forgotPassword } = useSelector((s) => s.auth.user);

    const [isFormValidated, setIsFormValidated] = useState(false);
    const [form, setForm] = useState({
        email: "",
    })

    const checkFormValidation = (data = form, appendKey, appendValue) => {
        let params = {...data};
        if (appendKey){ params = {...params, [appendKey]: appendValue}; }
        const errors = validate(params);
        if (errors){
            setIsFormValidated(false);
            // console.log("checkFormValidation", errors);
        }
        else{
            setIsFormValidated(true);
        }
    }
    
    const submitForm = async (e) => {
        e.preventDefault();
        const errors = validate(form);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            dispatch(auth.forgotPassword(form));
        }
    }

    useEffect(() => {
        if (forgotPassword === true){
            history.push("/reset-password");
            dispatch(auth.resetForgotPassword());
        }
        // eslint-disable-next-line
    }, [forgotPassword])


    return (
        <>

            <DynamicHeadTag
                headerText="Forgot Password"
            />

            <div className="p-8">
                <div>
                    
                    <div className="text-center">
                        <div className="text-2xl font-semibold">
                            Forgot Password
                        </div>
                    </div>

                    <div>
                        <form onSubmit={submitForm}>

                            <div className="mt-8 w-full max-w-md mx-auto md:mx-0 lg:w-96">
                                <Input
                                    type="email"
                                    label="Business Email"
                                    placeholder="mail@example.com"
                                    value={form.email}
                                    onChange={(e) => setForm({...form, email: e.target.value})}
                                    validationName="email"
                                    checkFormValidation={checkFormValidation} />

                                <ButtonLoader type="submit" loading={forgotPasswordLoading} disabled={!isFormValidated} className="btn btn-lg btn-block btn-ep-primary mt-8">
                                    Send reset mail
                                </ButtonLoader>

                                <div className="mt-3 text-sm text-gray-500 text-center">
                                    Remember your password? &nbsp;
                                    <Link to="/login" className="font-semibold text-ep-primary hover:underline">Log In</Link>
                                </div>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
            
        </>
    )
}
 

export default ForgotPassword;